/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Bold = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M14 12a4 4 0 0 0 0-8H6v8" }],
    ["path", { d: "M15 20a4 4 0 0 0 0-8H6v8Z" }]
  ]
];

export { Bold as default };
//# sourceMappingURL=bold.js.map
